




































import {Component, Prop, Vue} from 'vue-property-decorator';
import PartVideo from '@/components/Video/Video.vue';
import PartThreeMore from './PartThreeMore.vue';
import SwiperScroll from '@/components/SwiperScroll/SwiperScroll.vue';

@Component({
  components: {
    PartVideo,
    PartThreeMore,
    SwiperScroll,
  },
})
export default class PartThree extends Vue {
  private isLearnMore: boolean = false;
  private videoData: any = {
    poster: {
      src: require('@/assets/video/part3.png'),
      height: '8.61rem',
    },
    video: [
      {
        src: require('@/assets/video/part3.mp4'),
        type: 'video/mp4',
      },
    ],
  };

  private tabData: any = [
    {
      value: '3',
      unit: 'min',
      label: '极速换电',
    },
    {
      value: '90',
      unit: 'kW',
      label: '充电车快充',
    },
    {
      value: '80000',
      unit: '+',
      label: '公共直流桩接入',
    },
  ];

  private showLearnMore() {
    this.isLearnMore = true;
  }

  private closeLearnMore(flag: boolean) {
    this.isLearnMore = flag;
  }

}
